// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"0f52dc10","381":"7ee0bf77","851":"5e956877"}[chunkId] + ".chunk.css";
};